export default __webpack_public_path__ + "static/sa-etape3-083c9623cd4432f43aebb8c68da37890.jpeg";